
export const genderOptions = [
    { label: 'Male', value: 'male' },
    { label: 'Female', value: 'female' },
    { label: 'Other', value: 'other' },
  ];
  
  export const raceOptions = [
    { label: 'Asian', value: 'Asian' },
    { label: 'Black', value: 'Black' },
    { label: 'White', value: 'White' },
    { label: 'Hispanic', value: 'Hispanic' },
    { label: 'American Indian or Alaskan Native', value: 'American Indian or Alaskan Native' },
    { label: 'Native Hawaiian or Other Pacific Islander', value: 'Native Hawaiian or Other Pacific Islander' },
    { label: 'Other', value: 'Other' },
    { label: 'Prefer not to disclose', value: 'Prefer not to disclose' },
  ];
  
  export const majorOptions = [
    { label: 'Not applicable', value: 'not_applicable' },
    { label: 'Undecided', value: 'undecided' },
    { label: 'Accounting', value: 'accounting' },
    { label: 'Agricultural Science', value: 'agricultural_science' },
    { label: 'Architecture', value: 'architecture' },
    { label: 'Biology', value: 'biology' },
    { label: 'Business Administration', value: 'business_administration' },
    { label: 'Chemistry', value: 'chemistry' },
    { label: 'Civil Engineering', value: 'civil_engineering' },
    { label: 'Computer Science', value: 'computer_science' },
    { label: 'Economics', value: 'economics' },
    { label: 'Education', value: 'education' },
    { label: 'Electrical Engineering', value: 'electrical_engineering' },
    { label: 'Environmental Science', value: 'environmental_science' },
    { label: 'Finance', value: 'finance' },
    { label: 'Graphic Design', value: 'graphic_design' },
    { label: 'History', value: 'history' },
    { label: 'Human Resources', value: 'human_resources' },
    { label: 'International Relations', value: 'international_relations' },
    { label: 'Journalism', value: 'journalism' },
    { label: 'Marketing', value: 'marketing' },
    { label: 'Mathematics', value: 'mathematics' },
    { label: 'Mechanical Engineering', value: 'mechanical_engineering' },
    { label: 'Music', value: 'music' },
    { label: 'Nursing', value: 'nursing' },
    { label: 'Philosophy', value: 'philosophy' },
    { label: 'Physics', value: 'physics' },
    { label: 'Political Science', value: 'political_science' },
    { label: 'Psychology', value: 'psychology' },
    { label: 'Sociology', value: 'sociology' },
    { label: 'Theater', value: 'theater' },
  ];